module.exports = __webpack_public_path__ + "static/media/kyleconnolly.93df004a.png";